/**
 * Product-create SEO state. A new or resumed draft starts from its own payload,
 * never from another product's form. The URL slug stays empty or follows the
 * current name until the operator edits it.
 */

export interface WizardSeoFields {
  description: string;
  shortDescription: string;
  seoTitle: string;
  metaDescription: string;
  seoKeywords: string;
  urlSlug: string;
  slugEdited: boolean;
}

export const blankWizardSeo: WizardSeoFields = {
  description: "",
  shortDescription: "",
  seoTitle: "",
  metaDescription: "",
  seoKeywords: "",
  urlSlug: "",
  slugEdited: false,
};

export function slugFromProductName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function displayedUrlSlug(input: { name: string; urlSlug: string; slugEdited?: boolean }): string {
  if (input.slugEdited) return input.urlSlug;
  if (input.urlSlug.trim()) return input.urlSlug.trim();
  return slugFromProductName(input.name);
}

/** Replace the whole form from a draft payload. Missing SEO fields stay blank. */
export function formFromDraftPayload<T extends WizardSeoFields>(blank: T, payload: Partial<T> | null | undefined): T {
  const next = { ...blank, ...(payload ?? {}) };
  next.slugEdited = payload?.slugEdited === true || (payload?.slugEdited !== false && Boolean(payload?.urlSlug?.trim()));
  if (!payload?.urlSlug?.trim() && payload?.slugEdited !== true) next.urlSlug = "";
  return next;
}
